import {
    GET_QUIZ,
    GET_QUIZ_SUCCESS,

    CREATE_QUIZ,
    CREATE_QUIZ_SUCCESS,
    CLEAR_CREATED_QUIZ,

    ERASE_QUIZ_SUCCESS,

    GET_ALL_QUIZZES,
    GET_ALL_QUIZZES_SUCCESS,

    UPDATE_QUIZ,
    UPDATE_QUIZ_SUCCESS,

    DELETE_QUIZ,
    DELETE_QUIZ_SUCCESS,
    CLEAR_QUIZZES,

    UPDATE_QUIZ_INTRO,
    UPDATE_QUIZ_INTRO_SUCCESS,

    UPDATE_QUIZ_INTRO_SETTINGS,
    UPDATE_QUIZ_INTRO_SETTINGS_SUCCESS,

    UPDATE_QUIZ_REGISTRATION,
    UPDATE_QUIZ_REGISTRATION_SUCCESS,

    UPDATE_QUIZ_REGISTRATION_SETTINGS,
    UPDATE_QUIZ_REGISTRATION_SETTINGS_SUCCESS,

    UPDATE_QUIZ_RESULT,
    UPDATE_QUIZ_RESULT_SUCCESS,

    FILTER_QUIZZES,
    FILTER_QUIZZES_SUCCESS,

    UPDATE_QUIZ_RESULT_SETTINGS,
    UPDATE_QUIZ_RESULT_SETTINGS_SUCCESS,

    CHANGE_STATUS,
    CHANGE_STATUS_SUCCESS,

    GET_TENANT_STATISTIC,
    GET_TENANT_STATISTIC_SUCCESS,

    DUPLICATE_QUIZ,
    DUPLICATE_QUIZ_SUCCESS

} from './constants';

/**
 *
 * @param name
 * @param lang
 * @param quiz_type
 * @param person_type_count
 * @returns {{person_type_count: *, name: *, quiz_type: *, type: string, lang: *}}
 */
const createQuiz = ( { name, lang, quiz_type, person_type_count } ) => ( {
    type: CREATE_QUIZ,
    name,
    lang,
    quiz_type,
    person_type_count
} );
/**
 *
 * @param quiz
 * @returns {{quiz: *, type: string}}
 */
const createQuizSuccess = quiz => ( { type: CREATE_QUIZ_SUCCESS, quiz } );
/**
 *
 * @returns {{type: string}}
 */
const clearCreatedQuiz = () => ( { type: CLEAR_CREATED_QUIZ } );
/**
 *
 * @param title
 * @param lang
 * @param quizID
 * @returns {{quizID: *, type: string, title: *, lang: *}}
 */
const duplicateQuiz = ( title, lang, quizID ) => ( {
    type: DUPLICATE_QUIZ,
    title,
    lang,
    quizID
} );
/**
 *
 * @param quizess
 * @returns {{quizess: *, type: string}}
 */
const duplicateQuizSuccess = quizess => ( {
    type: DUPLICATE_QUIZ_SUCCESS,
    quizess
} );

/**
 *
 * @param typeQuiz
 * @param page
 * @param tenant
 * @param search
 * @param filter
 * @returns {{filter: *, typeQuiz: *, search: *, page: *, type: string, tenant: *}}
 */
const getAllQuizzes = ( typeQuiz, page, tenant, search, filter ) => ( {
    type: GET_ALL_QUIZZES,
    typeQuiz,
    page,
    tenant,
    search,
    filter
} );

/**
 *
 * @param quizzes
 * @param typeQuiz
 * @returns {{typeQuiz: *, quizzes: *, type: string}}
 */
const getAllQuizzesSuccess = ( quizzes, typeQuiz ) => ( {
    type: GET_ALL_QUIZZES_SUCCESS,
    quizzes: quizzes,
    typeQuiz: typeQuiz
} );
/**
 *
 * @param id
 * @param resolve
 * @returns {{resolve: *, id: *, type: string}}
 */
const getQuiz = ( id, resolve ) => ( {
    type: GET_QUIZ,
    id,
    resolve
} );
/**
 *
 * @param quiz
 * @returns {{quiz: *, type: string}}
 */
const getQuizSuccess = quiz => ( {
    type: GET_QUIZ_SUCCESS,
    quiz
} );
/**
 *
 * @param updatedQuizPiece
 * @param keyName
 * @param quizID
 * @param resolve
 * @returns {{resolve: *, quizID: *, keyName: *, type: string, updatedQuizPiece: *}}
 */
const updateQuiz = ( updatedQuizPiece, keyName, quizID, resolve ) => ( {
    type: UPDATE_QUIZ,
    updatedQuizPiece,
    keyName,
    quizID,
    resolve
} );
/**
 *
 * @param updatedQuizPiece
 * @returns {{type: string, updatedQuizPiece: *}}
 */
const updateQuizSuccess = updatedQuizPiece => ( {
    type: UPDATE_QUIZ_SUCCESS,
    updatedQuizPiece
} );
/**
 *
 * @param quizID
 * @returns {{quizID: *, type: string}}
 */
const deleteQuiz = quizID => ( {
    type: DELETE_QUIZ,
    quizID
} );
/**
 *
 * @param quizID
 * @returns {{quizID: *, type: string}}
 */
const deleteQuizSuccess = quizID => ( {
    type: DELETE_QUIZ_SUCCESS,
    quizID
} );
/**
 *
 * @returns {{type: string}}
 */
const clearQuizzes = () => ( { type: CLEAR_QUIZZES } );

/**
 *
 * @param quizID
 * @param intro
 * @param resolve
 * @returns {{resolve: *, quizID: *, intro: *, type: string}}
 */
const updateQuizIntro = ( quizID, intro, resolve ) => ( {
    type: UPDATE_QUIZ_INTRO,
    quizID,
    intro,
    resolve
} );
/**
 *
 * @param quiz
 * @returns {{quiz: *, type: string}}
 */
const updateQuizIntroSuccess = ( quiz ) => ( {
    type: UPDATE_QUIZ_INTRO_SUCCESS,
    quiz
} );
/**
 *
 * @param quizID
 * @param introSettings
 * @returns {{introSettings: *, quizID: *, type: string}}
 */
const updateQuizIntroSettings = ( quizID, introSettings ) => ( {
    type: UPDATE_QUIZ_INTRO_SETTINGS,
    quizID,
    introSettings
} );
/**
 *
 * @param quiz
 * @returns {{quiz: *, type: string}}
 */
const updateQuizIntroSettingsSuccess = ( quiz ) => ( {
    type: UPDATE_QUIZ_INTRO_SETTINGS_SUCCESS,
    quiz
} );
/**
 *
 * @param quizID
 * @param registration
 * @returns {{quizID: *, registration: *, type: string}}
 */
const updateQuizRegistration = ( quizID, registration ) => ( {
    type: UPDATE_QUIZ_REGISTRATION,
    quizID,
    registration
} );
/**
 *
 * @param quiz
 * @returns {{quiz: *, type: string}}
 */
const updateQuizRegistrationSuccess = ( quiz ) => ( {
    type: UPDATE_QUIZ_REGISTRATION_SUCCESS,
    quiz
} );
/**
 *
 * @param quizID
 * @param registrationSettings
 * @returns {{registrationSettings: *, quizID: *, type: string}}
 */
const updateQuizRegistrationSettings = ( quizID, registrationSettings ) => ( {
    type: UPDATE_QUIZ_REGISTRATION_SETTINGS,
    quizID,
    registrationSettings
} );
/**
 *
 * @param quiz
 * @returns {{quiz: *, type: string}}
 */
const updateQuizRegistrationSettingsSuccess = ( quiz ) => ( {
    type: UPDATE_QUIZ_REGISTRATION_SETTINGS_SUCCESS,
    quiz
} );
/**
 *
 * @param quizID
 * @param result
 * @returns {{result: *, quizID: *, type: string}}
 */
const updateQuizResult = ( quizID, result ) => ( {
    type: UPDATE_QUIZ_RESULT,
    quizID,
    result
} );
/**
 *
 * @param quiz
 * @returns {{quiz: *, type: string}}
 */
const updateQuizResultSuccess = ( quiz ) => ( {
    type: UPDATE_QUIZ_RESULT_SUCCESS,
    quiz
} );
/**
 *
 * @param quizID
 * @param resultSettings
 * @returns {{resultSettings: *, quizID: *, type: string}}
 */
const updateQuizResultSettings = ( quizID, resultSettings ) => ( {
    type: UPDATE_QUIZ_RESULT_SETTINGS,
    quizID,
    resultSettings
} );
/**
 *
 * @param quiz
 * @returns {{quiz: *, type: string}}
 */
const updateQuizResultSettingsSuccess = ( quiz ) => ( {
    type: UPDATE_QUIZ_RESULT_SETTINGS_SUCCESS,
    quiz
} );
/**
 *
 * @param typeQuiz
 * @param page
 * @param tenant
 * @param search
 * @param filter
 * @returns {{filter: *, typeQuiz: *, search: *, page: *, type: string, tenant: *}}
 */
const updateQuizFilter = ( typeQuiz, page, tenant, search, filter ) => ( {
    type: FILTER_QUIZZES,
    typeQuiz,
    page,
    tenant,
    search,
    filter
} );
/**
 *
 * @param quizzes
 * @returns {{quizzes: *, type: string}}
 */
const updateQuizFilterSuccess = quizzes => ( {
    type: FILTER_QUIZZES_SUCCESS,
    quizzes
} );
/**
 *
 * @param quizID
 * @returns {{quizID: *, type: string}}
 */
const changeStatusQuiz = quizID => ( {
    type: CHANGE_STATUS,
    quizID
} );
/**
 *
 * @param quiz
 * @returns {{quiz: *, type: string}}
 */
const changeStatusQuizSuccess = quiz => ( {
    type: CHANGE_STATUS_SUCCESS,
    quiz
} );
/**
 *
 * @param tenant
 * @param from
 * @param to
 * @returns {{from: *, to: *, type: string, tenant: *}}
 */
const getTenantStatistic = ( tenant, from, to ) => ( {
    type: GET_TENANT_STATISTIC,
    tenant,
    from,
    to
} );
/**
 *
 * @param statistics
 * @returns {{type: string, statistics: *}}
 */
const getTenantStatisticSuccess = statistics => ( {
    type: GET_TENANT_STATISTIC_SUCCESS,
    statistics
} );

const eraseQuizSuccess =() => ( {
    type: ERASE_QUIZ_SUCCESS
} );


export {
    eraseQuizSuccess,
    getQuiz,
    getQuizSuccess,
    createQuiz,
    clearCreatedQuiz,
    getAllQuizzes,
    getAllQuizzesSuccess,
    updateQuiz,
    updateQuizSuccess,
    createQuizSuccess,
    clearQuizzes,
    deleteQuiz,
    deleteQuizSuccess,
    updateQuizIntro,
    updateQuizIntroSuccess,
    updateQuizIntroSettings,
    updateQuizIntroSettingsSuccess,
    updateQuizRegistration,
    updateQuizRegistrationSuccess,
    updateQuizRegistrationSettings,
    updateQuizRegistrationSettingsSuccess,
    updateQuizResult,
    updateQuizResultSuccess,
    updateQuizResultSettings,
    updateQuizResultSettingsSuccess,
    updateQuizFilter,
    updateQuizFilterSuccess,
    changeStatusQuiz,
    changeStatusQuizSuccess,
    getTenantStatistic,
    getTenantStatisticSuccess,
    duplicateQuiz,
    duplicateQuizSuccess
};
